import React from 'react'
import {Col, Row} from "react-bootstrap";
import DatasourceStatusContextMenu from "components/common/NavContextMenu/DatasourceStatusContextMenu";
import styles from "./Styles.module.css"

export const DataSourceHandle = ({handle, submitHandleStatus}) => {
    const dispatchStatus = handle.dispatchStatus === "LIVE" ? "On" : handle.dispatchStatus;

    return (
        <div className={`color-grey-dark ${styles["panelRowWrapper"]}`} key={handle.id}>
            <Row>
                <Col sm={6} className={`font-14 ${styles["panelCol"]}`}>
                    <span className="trds-ellipsis padding-right-20">{handle.name}</span>
                </Col>
                <Col sm={3} className={styles.panelCol}>
                    Status -
                    <span className={`text-transform-upper-first ${styles['pl4']}`}>
                                    {handle.dispatchStatus === "LIVE" ? "On" : dispatchStatus}
                    </span>
                </Col>
                <Col sm={3} className={`${styles.panelCol} ${styles.justifyEnd}`}>
                    <DatasourceStatusContextMenu onClick={submitHandleStatus} handle={handle}/>
                </Col>
            </Row>
        </div>
    )

};

export const DataSourceHandles = ({handles, onClick}) => {
    return (
        handles.map(handle => {
            return (
                <DataSourceHandle handle={handle} submitHandleStatus={onClick} key={handle.id}/>
            )
        })
    )
};